import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormControl, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatFormFieldDefaultOptions, MatFormFieldModule } from '@angular/material/form-field';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RedirectGuard } from 'src/app/common/guards/redirect.guard';
import { WorkflowComponent } from './workflow.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { WorkflowTreeComponent } from './workflow-tree/workflow-tree.component';
import { WorkflowMainComponent } from './workflow-main/workflow-main.component';
import { WorkflowSectionsComponent } from './workflow-main/workflow-sections/workflow-sections.component';
import { WorkflowStepsComponent } from './workflow-main/workflow-steps/workflow-steps.component';
import { WorkflowTasksComponent } from './workflow-main/workflow-tasks/workflow-tasks.component';
import { WorkflowSectionComponent } from './workflow-main/workflow-sections/workflow-section/workflow-section.component';
import { WorkflowStepComponent } from './workflow-main/workflow-steps/workflow-step/workflow-step.component';
import { WorkflowTaskComponent } from './workflow-main/workflow-tasks/workflow-task/workflow-task.component';
import { AuthenticationGuard } from 'src/app/common/guards/authentication.guard';
import { ControlsModule } from 'src/app/controls/controls.module';

class TouchedErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

const appRoutes: Routes = [
  { path: 'workflow', component: WorkflowComponent, canActivate: [AuthenticationGuard], canDeactivate: [RedirectGuard] },
];

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};

@NgModule({
  declarations: [
    WorkflowComponent,
    WorkflowTreeComponent,
    WorkflowMainComponent,
    WorkflowSectionsComponent,
    WorkflowStepsComponent,
    WorkflowTasksComponent,
    WorkflowSectionComponent,
    WorkflowStepComponent,
    WorkflowTaskComponent,

  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    DragDropModule,
    FormsModule,
    HttpClientModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgbModule,
    ReactiveFormsModule,
    ScrollingModule,
    DatePipe,
    ControlsModule,
    QuillModule.forRoot(),
    SharedModule,
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: true,
        useHash: true,
        anchorScrolling: 'enabled',
        preloadingStrategy: PreloadAllModules,
      }
    ),
  ],
  exports: [RouterModule]
})
export class WorkflowModule { }
